<template>
  <div class="buttons-wrapper">
    
      <span v-b-modal.myModal class="delete-this-session">
        <i class="far fa-trash-alt" aria-hidden="true"></i>
        {{ $t('CALENDAR_ACTIVITY.deleteSessionModal.button')}}
      </span>
    

    <b-modal ref="deleteSessionModal" id="myModal">
      <div slot="modal-header">
        <span class="modal-title">
          {{ $t('CALENDAR_ACTIVITY.deleteSessionModal.title')}}
        </span>
      </div>
      {{ $t('CALENDAR_ACTIVITY.deleteSessionModal.modalConfirmation')}}
      <div slot="modal-footer">
        <button type="button" class="btn btn-type-3" @click="closeModal">{{ $t('CALENDAR_ACTIVITY.deleteSessionModal.cancel')}}</button>
        <button 
          v-loading-button="loadingDeleteBtn"
          type="button" 
          class="btn btn-type-4" 
          @click="deleteSessionOnClick">
          <span class="button-content">
            {{ $t('CALENDAR_ACTIVITY.deleteSessionModal.confirm')}}
          </span>
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { TOASTER_SUCCESS } from "@/common/events.types";

export default {
  name: 'DeleteSessionModal',
  props: [
    'activityId',
    'deleteActivity'
  ],
  data () {
    return {
      loadingDeleteBtn: false
    }
  },
  methods: {
    deleteSessionOnClick () {
      this.loadingDeleteBtn = true;
      this.deleteActivity({ activityId: this.activityId })
        .then(() => {
          this.$eventHub.$emit(TOASTER_SUCCESS, {
            message: this.$t('CALENDAR_ACTIVITY.toastMessages.deleteSessionmodal')
          })
          this.$refs.deleteSessionModal.hide()
          this.$router.push({ name: 'Calendar' })
          this.loadingDeleteBtn = false;
        })
        .catch(() => {
          this.loadingDeleteBtn = false;
        })
    },
    closeModal () {
      this.$refs.deleteSessionModal.hide()
    }
  }
}
</script>

<style lang="scss" scoped>
  .buttons-wrapper {
    float: right;
    .delete-this-session {
      margin-top: 15px;
      display: inline-block;
      font-size: 14px;
      color: $flush-mahogany;
      cursor: pointer;
      i {
        font-size: 18px;
        margin-right: 10px;
      }
    }
  }
  @media screen and (max-width: 992px) {
    .buttons-wrapper {
      float: left;
    }
  }
</style>

